// extracted by mini-css-extract-plugin
export default {"priority-modal":"NewWorkflow_priority-modal__XgrbG","actions":"NewWorkflow_actions__39IUt"};